import { Component, HostBinding, OnInit } from '@angular/core';
import { trigger, transition, style, animate, stagger, query } from "@angular/animations";
declare var $: any;

import { ActivatedRoute, Params } from '@angular/router';
import { urlEndPoint } from 'src/app/common';
import { Message } from 'src/app/models/message';
import { PubClassif } from 'src/app/models/obs/pubclassif';
import { Publication } from 'src/app/models/obs/publication';
import { PubTematic } from 'src/app/models/obs/pubtematic';
import { Tematic } from 'src/app/models/obs/tematic';
import { PubclassifService } from 'src/app/services/obs/pubclassif.service';

import { PublicationService } from 'src/app/services/obs/publication.service';
import { PubtematicService } from 'src/app/services/obs/pubtematic.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { HtmlutilsService } from 'src/app/services/util/htmlutils.service';
import { ClassificationService } from 'src/app/services/obs/classification.service';
import { Classification } from 'src/app/models/obs/classification';
import { Tier1 } from 'src/app/models/obs/tier1';
import { Tier1Service } from 'src/app/services/obs/tier1.service';

import { CompendioService } from 'src/app/services/obs/compendio.service'; //Agregado para compendio
import { Compendio } from 'src/app/models/obs/compendio'; //Agregado para compendio
import { Location } from '@angular/common';

type PublicationItem = Publication | { groupTitle: string };
@Component({
  selector: 'app-publication',
  templateUrl: './publication.component.html',
  styleUrls: ['./publication.component.scss'],
  animations: [
    trigger('pageAnimations', [
      transition(':enter', [ // each time the binding value changes
        query('.title-module, .p-year', [
          style({ opacity: 0 }),
          stagger(500, [
            animate('1s 100ms', style({ opacity: 1 }))
          ]),
        ])
      ], { delay: 100 },)
    ])
  ]
})
export class PublicationComponent implements OnInit {

  @HostBinding('@pageAnimations')
  public animatePage = false;

  idEvenType: string = '4';


  dataCarousel: any = [
    { longtitle: 'Encuentra las publicaciones por clasificación', img: '/uploads/pubs/b1.webp', eventtype: 'Tendencias' },
    { longtitle: 'Publicaciones en temas de riesgos', img: '/uploads/pubs/b2.webp', eventtype: 'Riesgos' },
    { longtitle: 'Publicaciones en temas de futuros', img: '/uploads/pubs/b3.webp', eventtype: 'Eventos futuros y Foros del futuro' },
    { longtitle: 'Publicaciones en temas de escenarios', img: '/uploads/pubs/b4.webp', eventtype: 'Escenarios' },
  ]

  constructor(
    private t1S: Tier1Service,
    private publicationService: PublicationService,
    private classificationService: ClassificationService,
    private pubClassifService: PubclassifService,
    private activedRoute: ActivatedRoute,
    private htmlUtil: HtmlutilsService,
    private compendioService: CompendioService, //Agregado para compendio
  ) { }

  pubs: Publication[] = [];
  //filteredPubs: Publication[] = [];
  filteredPubs: PublicationItem[] = [];
  filteredPubsByYear: Publication[] = [];
  filteredPubsByClassif: Publication[] = [];
  pubClassif: PubClassif[] = [];
  pubTematic: PubTematic[] = [];
  classif: Classification[] = [];
  tematic: Tematic[] = [];
  years: number[] = [];
  selectedYear: number = 0;
  selectedClassif: number = 0;
  selectedTematic: number = 0;
  msg: Message;

  URL: string = urlEndPoint;
  params: Params;
  t1: Tier1;
  compendio: Compendio[] = []; //AGREGADO PARA COMPENDIO

  searchTerm: string = ''; // Variable para almacenar el término de búsqueda
  filteredPubsByTitle: any[] = [];
  filteredPublications: Publication[] = [];
  selectedOrder: string = '0'; //Para seleccion por orden
  ResultNoEncontrados: boolean = false; //Para hacer aseguimiento a resultados

  ngOnInit() {
    this.params = this.activedRoute.snapshot.params;
    this.getInitialText();
    this.getClassifications();
    this.getPubs();
    this.getCompendio()
    this.getYears();
  }

  getInitialText() {
    this.t1S.getOne(28).subscribe(
      res => {
        this.t1 = res['data'];
      },
      err => {
        console.error("algo salio mal!")
      }
    );
  }

  // Método para filtrar las publicaciones usando el buscador
  filterByTitle() {
    this.setDefaultOrder();
    this.setDefaultYear();
    this.clearCompendioCheckboxes();
    this.clearClassificationCheckboxes();
    if (this.searchTerm.trim() !== '') {
      this.filteredPubs = this.pubs.filter(pub =>
        pub.name.toLowerCase().includes(this.searchTerm.toLowerCase()),
      );
      console.log("Longitud:", this.filteredPubs.length)
      if (this.filteredPubs.length === 0) {
        this.ResultNoEncontrados = true
      }
      else {
        this.ResultNoEncontrados = false
      }
    } else {
      this.filteredPubs = this.pubs;
    }
  }

  // Método que se llama cada vez que cambia el valor del campo de búsqueda
  onSearchChange(searchValue: string) {
    this.searchTerm = searchValue;
    if (this.searchTerm.length === 0) {
      this.filteredPubs = this.pubs
      this.clearCompendioCheckboxes();
      this.clearClassificationCheckboxes();
      this.ResultNoEncontrados = false
    }
  }

  selectedClassifications: Set<number> = new Set<number>();
  selectedCompendio: Set<number> = new Set<number>();

  getclasifComp(id: number) {
    this.classificationService.getAll().subscribe(
      async res => {
        const data = res['data'];

        // Filtrar solo las clasificaciones asociadas al compendio seleccionado
        const clasificacionesFiltradas = data.filter((clasificacion: any) => clasificacion.obCompendioId === id);

        // Marcar automáticamente las casillas de verificación de las clasificaciones asociadas
        clasificacionesFiltradas.forEach(clasificacion => {
          const checkboxId = `cl${clasificacion.id}`;
          const checkboxElement = document.getElementById(checkboxId) as HTMLInputElement;
          if (checkboxElement) {
            checkboxElement.checked = true;
            this.selectedClassifications.add(clasificacion.id);
          }
        });

        // Realizar el filtrado una vez después de seleccionar el compendio
        this.performClassificationFiltering();
      },
      err => {
        console.error("Error al obtener los datos del servidor:", err);
        this.msg = err;
      }
    );
  }

  getPubClassif(id: string) {
    this.pubClassifService.getByClassif(id).subscribe(
      async res => {
        this.pubClassif = res['data'] as PubClassif[];
        if (this.pubClassif && this.pubClassif.length > 0) {
          const classification = this.classif.find(c => c.id === +id); // Obtener la clasificación
          const groupTitle = classification ? classification.title : "Sin Clasificación"; // Obtener el título de la clasificación o establecer un valor por defecto si no se encuentra
          const filtered = this.pubs.filter(p => {
            return this.pubClassif.some(classif => classif.idpublication === p.id);
          });
          // Agregar el título de la clasificación al arreglo de resultados filtrados como una nueva publicación con un atributo adicional groupTitle
          this.filteredPubs.push({ groupTitle });
          this.filteredPubs.push(...filtered.map(pub => ({ ...pub, groupTitle: '' }))); // Asegura que las publicaciones no tengan un título de grupo
        } else {
          console.log("No se encontraron datos de pubClassif");
        }
      },
      err => { this.msg = err; }
    );
  }

  getCompendio() {
    this.compendioService.getAll().subscribe(
      async (res) => {
        this.compendio = res['data'];
        console.log("compendium : ", this.compendio);
        
      },
      (err) => {
        this.msg = err;
      }
    );
  }
  getClassifications() {
    this.classificationService.getAll().subscribe(
      async res => {
        this.classif = res['data'];
      },
      err => { this.msg = err; }
    );
  }

  getPubs() {
    this.publicationService.getAll().subscribe(
      async res => {
        this.pubs = res['data'];
        this.filteredPubs = this.pubs;
      },
      err => { this.msg = err; }
    );
  }

  performClassificationFiltering() {
    if (this.selectedClassifications.size > 0) {
      this.filteredPubs = [];
      for (const selectedId of this.selectedClassifications) {
        if (selectedId === 0) {
          this.selectedClassif = 0;
          this.filteredPubs.push(...this.pubs);
        } else {
          this.selectedClassif = selectedId;
          this.getPubClassif(selectedId.toString());
        }
      }
    } else {
      this.filteredPubs = this.pubs;
    }

  }

  filterByClassif(event: any, id: number) {
    this.clearFormSearch();
    const isChecked = event.target.checked;
    if (isChecked) {
      this.selectedClassifications.add(id);

      const classification = this.classif.find(c => c.id === id);
      if (classification) {
        const compendioCheckboxId = `flexCheckDefault${classification.obCompendioId}`;
        const compendioCheckboxElement = document.getElementById(compendioCheckboxId) as HTMLInputElement;
        if (compendioCheckboxElement) {
          compendioCheckboxElement.checked = true;
          this.selectedCompendio.add(classification.obCompendioId);
        }
      }
    } else {
      this.selectedClassifications.delete(id);

      const classification = this.classif.find(c => c.id === id);
      if (classification) {
        // Verificar si todas las clasificaciones asociadas al compendio están desmarcadas
        const compendioClassifications = this.classif.filter(c => c.obCompendioId === classification.obCompendioId);
        const allUnchecked = compendioClassifications.every(c => !this.selectedClassifications.has(c.id));

        if (allUnchecked) {
          const compendioCheckboxId = `flexCheckDefault${classification.obCompendioId}`;
          const compendioCheckboxElement = document.getElementById(compendioCheckboxId) as HTMLInputElement;
          if (compendioCheckboxElement) {
            compendioCheckboxElement.checked = false;
            this.selectedCompendio.delete(classification.obCompendioId);
          }
        }
      }
    }
    this.setDefaultOrder();
    this.setDefaultYear();
    this.performClassificationFiltering();
  }

  filterByCompendio(eventComp: any, idcompendio: number, name: string) {
    this.clearFormSearch();
    const check = eventComp.target.checked;
    if (check) {
      this.selectedCompendio.add(idcompendio);
      this.getclasifComp(idcompendio);
    } else {
      this.selectedCompendio.delete(idcompendio);
      // Filtrar las clasificaciones asociadas al compendio deseleccionado

      this.classificationService.getAll().subscribe(
        async res => {
          const data = res['data'];

          // Filtrar solo las clasificaciones asociadas al compendio seleccionado
          const clasificacionesDeseleccionadas = data.filter((clasificacion: any) => clasificacion.obCompendioId === idcompendio);
          // Desmarcar las casillas de verificación de las clasificaciones deseleccionadas
          clasificacionesDeseleccionadas.forEach(clasificacion => {
            const checkboxId = `cl${clasificacion.id}`;
            const checkboxElement = document.getElementById(checkboxId) as HTMLInputElement;
            if (checkboxElement) {
              checkboxElement.checked = false;
              this.selectedClassifications.delete(clasificacion.id);
            }
          });
          // Realizar el filtrado una vez después de seleccionar el compendio
          this.performClassificationFiltering();
        },
        err => {
          console.error("Error al obtener los datos del servidor:", err);
          this.msg = err;
        }
      );
    }
    this.setDefaultOrder();
    this.setDefaultYear();
  }

  applyOrder(order: string) {
    this.selectedOrder = order;
    this.setDefaultYear();
    this.clearCompendioCheckboxes();
    this.clearClassificationCheckboxes();
    this.clearFormSearch();
    switch (this.selectedOrder) {
      case "0": // Mostrar todas las publicaciones (sin orden)
        this.filteredPubs = this.pubs;
        break;
      case "1": // Ordenar de A-Z por título
        this.filteredPubs = this.pubs.slice().sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "2": // Ordenar de Z-A por título
        this.filteredPubs = this.pubs.slice().sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "3": // Ordenar de más reciente a más antiguo
        this.filteredPubs = this.pubs.slice().sort((a, b) => new Date(b.publication_date).getTime() - new Date(a.publication_date).getTime());
        break;
      case "4": // Ordenar de más antiguo a más reciente
        this.filteredPubs = this.pubs.slice().sort((a, b) => new Date(a.publication_date).getTime() - new Date(b.publication_date).getTime());
        break;
      default:
        break;
    }
  }

  filterByYear(year: number) {
    this.setDefaultOrder();
    this.clearCompendioCheckboxes();
    this.clearClassificationCheckboxes();
    this.clearFormSearch();
    switch (true) {
      case year == 0: {
        this.filteredPubs = this.pubs;
        this.selectedYear = 0;
        break;
      }
      case (year > 0): {
        this.selectedYear = year;
        this.filteredPublications = this.pubs.filter(p => (new Date(p.publication_date).getFullYear() == year));
        this.filteredPubs = this.filteredPublications;
        break;
      }
      default: {
        this.filteredPubs = [];
        break;
      }
    }
    if (this.filteredPubs.length === 0) {
      this.ResultNoEncontrados = true
    }
    else {
      this.ResultNoEncontrados = false
    }
  }

  getYears() {
    this.publicationService.getYears().subscribe(
      res => {
        this.years = res['data'][0];
      },
      err => { this.msg = err; }
    );
  }

  //Función para establecer el select de orden por defecto
  setDefaultOrder() {
    const selectOrder = document.getElementById('select-order') as HTMLSelectElement;
    if (selectOrder) {
      selectOrder.selectedIndex = 0;
    }
  }

  // Función para establecer el año por defecto
  setDefaultYear() {
    this.selectedYear = 0;
    const selectYear = document.getElementById('select-year') as HTMLSelectElement;
    if (selectYear) {
      selectYear.selectedIndex = 0;
    }
  }
  //Funciones para establecer valores por defecto a las casillas de compendio y clasificacion
  clearCompendioCheckboxes() {
    this.selectedCompendio.clear();
    const compendioCheckboxes = document.querySelectorAll('.form-check-input[id^="flexCheckDefault"]');
    compendioCheckboxes.forEach((checkbox: HTMLInputElement) => {
      checkbox.checked = false;
    });
  }

  clearClassificationCheckboxes() {
    this.selectedClassifications.clear();
    const classificationCheckboxes = document.querySelectorAll('.form-check-input[id^="cl"]');
    classificationCheckboxes.forEach((checkbox: HTMLInputElement) => {
      checkbox.checked = false;
    });
  }

  //Funcion para limipar el formulario de busqueda
  clearFormSearch() {
    const inputElement = document.querySelector('.form-control') as HTMLInputElement;
    inputElement.value = '';
    this.searchTerm = '';
  }

}